import * as React from "react";

const RightArrow = (props) => {
  return (
    <svg viewBox="0 0 752 752" {...props}>
      <g fill="#012f49">
        <path d="M586.7 339.96 431.32 184.63a48.69 48.69 0 0 0-81.461 21.825 48.68 48.68 0 0 0 12.602 47.031l122.47 122.52-122.47 122.52a48.688 48.688 0 0 0 0 68.86 48.688 48.688 0 0 0 68.86 0l155.38-155.34a48.54 48.54 0 0 0 14.207-34.477v-1.563a48.691 48.691 0 0 0-14.207-36.039z" />
        <path d="M403.8 377.56v-1.563a48.691 48.691 0 0 0-14.207-36.039l-155.43-155.33a48.697 48.697 0 0 0-47.031-12.604 48.697 48.697 0 0 0-34.43 34.43 48.68 48.68 0 0 0 12.602 47.03l122.52 122.52-122.52 122.52a48.705 48.705 0 0 0-14.262 34.43 48.697 48.697 0 0 0 48.692 48.692 48.687 48.687 0 0 0 34.43-14.262l155.38-155.34a48.732 48.732 0 0 0 14.254-34.477z" />
      </g>
    </svg>
  );
}

export default RightArrow;
